import { render, staticRenderFns } from "./ChartExpiresSoonWarehouseItems.vue?vue&type=template&id=153e78f2"
import script from "./ChartExpiresSoonWarehouseItems.vue?vue&type=script&lang=js"
export * from "./ChartExpiresSoonWarehouseItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports